export default function ProjectModal({ project, onClose }) {
  const allTechs = ["Flutter", "Dart", "React", "Node.js", "MongoDB", "Firebase", "Firestore", "Auth", "MVVM", "Provider", "API", "Konum Servisleri", "Location Services", "shared_preferences", "just_audio", "audio_service", "HTML", "CSS", "JavaScript", "TypeScript", "SQL"];
  const extractedTechs = allTechs.filter(tech => {
    const escapedTech = tech.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const regex = new RegExp(`\\b${escapedTech}\\b`, 'i');
    return regex.test(project.description || '');
  });

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose} id="project-modal-close">×</button>
        
        <div className="project-modal-header">
          <div className="card-icon" style={{margin: 0, flexShrink: 0}}>
            {project.icon ? (
              <img src={project.icon} alt={project.title} style={{borderRadius: '16px'}} />
            ) : (
              <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09z"/><path d="m12 15-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z"/></svg>
            )}
          </div>
          <h3 className="project-modal-title">{project.title}</h3>
        </div>

        <div className="project-modal-section">
          <h4 className="project-modal-label">Project Details</h4>
          <p className="project-modal-desc">{project.description}</p>
        </div>

        {extractedTechs.length > 0 && (
          <div className="project-modal-section">
            <h4 className="project-modal-label">Technologies</h4>
            <div className="tech-tags">
              {extractedTechs.map((tech, i) => (
                <span key={i} className="tech-tag">{tech}</span>
              ))}
            </div>
          </div>
        )}

        <div className="project-modal-actions">
          <a href={project.githubLink} target="_blank" rel="noopener noreferrer" className="btn-primary" id="project-github-btn">
            <svg width="20" height="20" viewBox="0 0 16 16" fill="currentColor"><path d="M8 0C3.58 0 0 3.58 0 8a8 8 0 0 0 5.47 7.59c.4.07.55-.17.55-.38 0-.19-.01-.82-.01-1.49-2.01.37-2.53-.49-2.69-.94-.09-.23-.48-.94-.82-1.13-.28-.15-.68-.52-.01-.53.63-.01 1.08.58 1.23.82.72 1.21 1.87.87 2.33.66.07-.52.28-.87.51-1.07-1.78-.2-3.64-.89-3.64-3.95 0-.87.31-1.59.82-2.15-.08-.2-.36-1.02.08-2.12 0 0 .67-.21 2.2.82.64-.18 1.32-.27 2-.27.68 0 1.36.09 2 .27 1.53-1.04 2.2-.82 2.2-.82.44 1.1.16 1.92.08 2.12.51.56.82 1.27.82 2.15 0 3.07-1.87 3.75-3.65 3.95.29.25.54.73.54 1.48 0 1.07-.01 1.93-.01 2.2 0 .21.15.46.55.38A8 8 0 0 0 16 8c0-4.42-3.58-8-8-8z" /></svg>
            View on GitHub
          </a>
        </div>
      </div>
    </div>
  );
}
